import { Box } from "@chakra-ui/react";

type IProps = {
  Header?: React.ReactElement;
  Body?: React.ReactElement;
};

const LessonLayout = ({ Header, Body }: IProps) => {
  return (
    <Box>
      <Box
        minH={{ base: "4rem", md: "4.4rem" }}
        width={"full"}
        position={"fixed"}
        zIndex={"sticky"}
        top={0}
        border={"none"}
      >
        {Header}
      </Box>
      <Box maxWidth={["full", "34rem"]} m="auto">
        {Body}
      </Box>
    </Box>
  );
};

export default LessonLayout;
